import { Controller } from "@hotwired/stimulus"
import ga from "../utils/ga"

export default class extends Controller {
  static values = {
    open: Boolean,
    focused: Boolean,
    searchModalInputEventSent: Boolean,
  }

  static targets = ["pill", "category", "form", "input"]

  open(e) {
    e.preventDefault()
    this.openValue = true
    this.inputTarget.focus()
  }

  close(e) {
    e.preventDefault()
    this.openValue = false
    this.resetForm()
  }

  selectPill(e) {
    this.categoryTarget.value = e.currentTarget.dataset.pillValue
    this.pillTargets.forEach((el) => {
      el.removeAttribute("data-selected")
      if (el.dataset.pillValue === this.categoryTarget.value) {
        el.dataset.selected = true
      }
    })

    ga("send", {
      hitType: "event",
      eventCategory: "page-header-top;search bar",
      eventAction: "click;pill",
      eventLabel: this.categoryTarget.value,
    })
  }

  trackSearchEvent() {
    // If someone actually does a search, then we don't want to send the scheduled inline close event.
    clearTimeout(this.inlineCloseEventTimeout)

    ga("send", {
      hitType: "event",
      eventCategory: "page-header-top;search bar",
      eventAction: "click",
      eventLabel: "search",
    })
  }

  resetForm() {
    // After the form is submitted we need to clear the values from the input field and set the pills
    // back to a default state of having "All" selected.
    // We also reset the form if the modal is closed before doing a search.
    this.inputTarget.value = ""
    this.searchModalInputEventSentValue = false
    this.pillTargets.forEach((el) => {
      el.dataset.pillValue === "all" ? (el.dataset.selected = "true") : (el.dataset.selected = "false")
    })
  }

  focusSearchUi() {
    // We set some data attributes so we can keep the "hover" state alive on our inline search box
    // while the user is focused in the search input box. Otherwise they can move the mouse outside of the box
    // while typing and the search box will fade away.
    this.focusedValue = true
  }

  blurSearchUi() {
    // Only blur the UI if there is no text in the search box
    const hasTextInSearchInput = this.inputTarget.value.length > 0
    if (!hasTextInSearchInput) {
      this.focusedValue = false
    }
  }

  sendInlineOpenEvent() {
    // We want to mimic the same "open" and "close" events for the inline search box.
    // When someone focuses on the inline search box we send the same "open" event as if they've opened the modal.
    ga("send", {
      hitType: "event",
      eventCategory: "page-header-top;search bar",
      eventAction: "click",
      eventLabel: "open search",
    })
  }

  sendInlineCloseEvent() {
    // We want to mimic the same "open" and "close" events for the inline search box.
    // When someone leaves the inline search box we want to send the same "close" event as if they've closed the modal.
    // But only if they aren't in the process of submitting a search...
    this.inlineCloseEventTimeout = setTimeout(() => {
      this.searchModalInputEventSentValue = false

      ga("send", {
        hitType: "event",
        eventCategory: "page-header-top;search bar",
        eventAction: "click",
        eventLabel: "close;outside",
      })
    }, 200)
  }

  sendAttemptToSearchEvent() {
    if (!this.searchModalInputEventSentValue) {
      this.searchModalInputEventSentValue = true

      ga("send", {
        hitType: "event",
        eventCategory: "page-header-top;search bar",
        eventAction: "click",
        eventLabel: "input",
      })
    }
  }
}
